import { createGlobalStyle } from 'styled-components';
import { media } from './style-utils';

export default createGlobalStyle`
  :root {
    /* Foundation */
    --c-charcoal: hsl(227, 13%, 21%);
    --c-shark: hsl(227, 17%, 13%);
    --c-berlin: hsl(240, 24%, 96%);
    --c-white: hsl(0, 0%, 100%);

    /* Auxiliary */
    --c-slate: hsl(226, 6%, 41%);
    --c-manatee: hsl(227, 7%, 59%);
    --c-silver: hsl(240, 11%, 91%);
    --c-gray: hsl(200, 2.6%, 45.9%);
    --c-ral: hsl(232, 16%, 18%);
    --c-pearl: hsl(0, 0%, 94%);

    /* Product */
    --c-red: hsl(347, 99%, 60%);
    --c-turquoise: hsl(180, 47%, 43%);
    --c-gold: hsl(33, 32%, 40%);

    /* Interface */
    --c-black: hsl(210, 16%, 10%);
    --c-green: hsl(141, 76%, 59%);
    --c-yellow: hsl(56, 91%, 58%);

    /* Spacing */
    --fr: 1rem;

  /* Font Family */
    --ff-display: var(--ff-sans);
    --lh: 1.428571429;

    /* Font sizes */
    --fs-xs: var(--size-00);
    --fs-base: var(--size-00);
    --fs-focus: var(--size-100);
    --fs-s: var(--size-200);
    --fs-sm: var(--size-300);
    --fs-m: var(--size-400);
    --fs-ml: var(--size-500);
    --fs-l: var(--size-600);
    --fs-xl: var(--size-700);
    --fs-xxl: var(--size-800);
    --fs-xxxl: var(--size-900);

    --default-vertical-padding: 3rem;

    ${media.mediumLarge`
      --default-vertical-padding: 5rem;
    `};

    --default-horizontal-padding: 1rem;

    ${media.mediumLarge`
      --default-horizontal-padding: 3.5rem;
    `};

    ${media.large`
      --default-horizontal-padding: 6.5rem;
    `};

    --padding-m: 5rem;
    --padding-l: 8rem;
  }
`;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/styles/variables.js